import { createFileRoute } from "@tanstack/react-router";
import WhatIsCargoNova from "@/pages/WhatIsCargoNova";
import { pageHead } from "@/lib/seo";
import { whatIsCargoNovaBreadcrumb } from "@/utils/schema";

export const Route = createFileRoute("/zh/what-is-cargonova")({
  head: () => ({
    ...pageHead("/what-is-cargonova", "zh"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(whatIsCargoNovaBreadcrumb("zh")),
      },
    ],
  }),
  component: WhatIsCargoNova,
});
